import React, { useContext, useEffect, useMemo, useState } from "react";
import Navbar from "../../../components/Navbar";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Link, useNavigate, useOutletContext, useParams } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import {
  approveVendor,
  declineVendor,
} from "../../PendingApproval/Vendor/Helper";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { addVendorManually, deleteVendor } from "./Helper";
import { getAllVendors, getVendorChildUsers, vendorListHeaders } from "./Helper";
import { hasAddonProductAccess, updateUserProductAccess } from "../../../utils/common/api";
import { IconButton, Switch, Select, MenuItem, FormControl } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LoginIcon from "@mui/icons-material/Login";
import { Button, TablePagination } from "@mui/material";
import { useDebounce, useQueryParams } from "../../../hooks";
import { DeactivateUserModal } from "../../../components/common";
import countryData from 'country-calling-code';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import SignupForm from "../../../components/SignupForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const isProduction = window.location.hostname === 'cms.prolegion.com';

const MANAGE_BY_EMAIL_MAP = isProduction
  ? {
    'suraj@prolegion.com': 'SURAJ',
    'anurag@prolegion.com': 'ANURAG',
  }
  : {
    'harsh45@yopmail.com': 'MAX',
    'harsh46@yopmail.com': 'ELEVEN',
  };

const MANAGE_BY_OPTIONS = isProduction
  ? [
    { email: 'suraj@prolegion.com', name: 'SURAJ' },
    { email: 'anurag@prolegion.com', name: 'ANURAG' },
  ]
  : [
    { email: 'harsh45@yopmail.com', name: 'MAX' },
    { email: 'harsh46@yopmail.com', name: 'ELEVEN' },
  ];

const VendorUserList = ({ isChildUser = false }) => {
  const context = useOutletContext();
  const [vendor, setVendor] = useState([]);
  const { getParam, getAllQueryParamString, setMultiParam, removeParam } = useQueryParams();
  const [userPermissions, setUserPermissions] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const currentPage = getParam("page");
  const currentLimit = getParam("pageSize");
  const [vendorPage, setVendorPage] = useState(parseInt(currentPage) || 0);
  const [vendorLimit, setVendorLimit] = useState(parseInt(currentLimit) || 9);
  const [vendorTotal, setVendorTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showAddVendorModal, setShowAddVendorModal] = useState(false);
  const [isCreatingVendor, setIsCreatingVendor] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [toggle, setToggle] = useState(true);
  const [search, setSearch] = useState(isChildUser ? '' : (getParam("search") || ''))
  const [open, setOpen] = useState(false);
  const [vendorInfo, setVendorInfo] = useState({ id: "" });
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const debounceSearch = useDebounce(search, 1000);
  const [updatingAccessId, setUpdatingAccessId] = useState(null);
  const { userid } = useParams()

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
    setSuccessMessage('');
    setErrorMessage('');
  };

  const handleChangePage = (event, newPage) => {
    fetchData(newPage, vendorLimit);
    setVendorPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setVendorLimit(parseInt(event.target.value, 10));
    setVendorPage(0);
    fetchData(0, parseInt(event.target.value, 10));
  };

  const fetchData = (page, limit) => {
    if (isChildUser) {
      getVendorChildUsers(page, limit, '', userid, fromDate || null, toDate || null).then((data) => {
        setVendor(data.data.result);
        setVendorTotal(data.data.count);
      })
    } else {
      getAllVendors(page, limit, '', fromDate || null, toDate || null)
        .then((data) => {
          setVendor(data.data.vendors.rows);
          setVendorTotal(data.data.vendors.totalItems);
        })
        .catch((err) => console.log(err));
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    setMultiParam({ "page": vendorPage, "pageSize": vendorLimit });
  }, [vendorPage, vendorLimit]);

  useEffect(() => {
    context(["User Manager", "Vendor"]);
    if (isChildUser) {
      getVendorChildUsers(vendorPage, vendorLimit, debounceSearch, userid, fromDate || null, toDate || null).then((data) => {
        setVendor(data.data.result);
        setVendorTotal(data.data.count);
      })
    } else {
      getAllVendors(vendorPage, vendorLimit, debounceSearch, fromDate || null, toDate || null)
        .then((data) => {
          setVendor(data.data.vendors.rows);
          setVendorTotal(data.data.vendors.totalItems);
        })
        .catch((err) => console.log(err));
    }
  }, [toggle, vendorPage, vendorLimit, debounceSearch, fromDate, toDate]);

  useEffect(() => {
    const cmsPermissions = localStorage.getItem('CMSUsersPermission');
    if (cmsPermissions) {
      setUserPermissions(JSON.parse(cmsPermissions));
      setIsAdmin(false);
    } else {
      setUserPermissions([]);
      setIsAdmin(true);
    }
  }, []);
  const viewClient = (e, id) => {
    e.preventDefault();
  };

  const removeVendor = () => {
    deleteVendor(vendorInfo.id)
      .then((data) => {
        setToggle(!toggle);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => { }, [toggle]);

  const handleAddVendor = async (formData) => {
    setIsCreatingVendor(true);

    const payload = {
      email: formData.email,
      companyName: formData.companyName,
      firstName: formData.firstName,
      lastName: formData.lastName,
      password: formData.password,
      phone: formData.phone,
      website: formData.website || '',
      countryCode: formData.countryCode,
      utmSource: formData.utmSource || "",
      role: "VENDOR",
    };
    if (formData.branding_logo) {
      payload.branding_logo = formData.branding_logo;
    }
  
    try {
      await addVendorManually(payload);
      fetchData(vendorPage, vendorLimit);
      setSuccessMessage('Vendor created successfully!');
      setOpenSnackbar(true);
      setShowAddVendorModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      setErrorMessage('Error creating vendor. Please try again.');
      setOpenSnackbar(true);
    } finally {
      setIsCreatingVendor(false);
    }
  };
  const vendorMapping = useMemo(() => {
    return vendor.map((item) => ({
      ...item,
      // clients: <Link to={`cvr-list/${item?.id}?connectiontitle=CLIENT`}>View Clients List</Link>,
      // vendors: <Link to={`cvr-list/${item?.id}?connectiontitle=VENDOR`}>View Vendors List</Link>,
      // resources: <Link to={`cvr-list/${item?.id}?connectiontitle=RESOURCE`}>View Resources List</Link>,
    }))
  }, [vendor]);

  const renderVendorList = (item, index) => (
    <th 
      scope="col" 
      class="py-3 px-6 uppercase whitespace-nowrap" 
      key={index}
      style={item === "Date/Time Created" ? { minWidth: '180px' } : {}}
    >
      {item}
    </th>
  )

  const handleNavigateVendorInfo = (id, userName) => {
    navigate(`vendor-info/${id}${getAllQueryParamString}&&user-name=${userName}`)
  }

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    if (!isChildUser) {
      setMultiParam({"search": searchValue});
    }
  }

  const switchHandler = async (vendorDetails, val) => {
    await approveVendor(vendorDetails.id, false, { selfManagedResources: !!val })
    if (isChildUser) {
      getVendorChildUsers(vendorPage, vendorLimit, debounceSearch, userid, fromDate || null, toDate || null).then((data) => {
        setVendor(data.data.result);
        setVendorTotal(data.data.count);
      })
    } else {
      getAllVendors(vendorPage, vendorLimit, debounceSearch, fromDate || null, toDate || null)
        .then((data) => {
          setVendor(data.data.vendors.rows);
          setVendorTotal(data.data.vendors.totalItems);
        })
        .catch((err) => console.log(err));
    }
  }

const vendorPoolSwitchHandler = async (vendorDetails, val) => {
  try {
    await approveVendor(vendorDetails.id, false, { show_in_vendor_pool: !!val });
    if (isChildUser) {
      const { data } = await getVendorChildUsers(vendorPage, vendorLimit, debounceSearch, userid);
      setVendor(data.result);
      setVendorTotal(data.count);
    } else {
      const { data } = await getAllVendors(vendorPage, vendorLimit, debounceSearch);
      setVendor(data.vendors.rows);
      setVendorTotal(data.vendors.totalItems);
    }
  } catch (error) {
    console.error("Error updating Vendor Pool:", error);
  }
};

  const showCompanyNameSwitchHandler = async (vendorDetails, val) => {
    await approveVendor(vendorDetails.id, false, { showCompanyNameInJobPost: !!val })
    if (isChildUser) {
      getVendorChildUsers(vendorPage, vendorLimit, debounceSearch, userid, fromDate || null, toDate || null).then((data) => {
        setVendor(data.data.result);
        setVendorTotal(data.data.count);
      })
    } else {
      getAllVendors(vendorPage, vendorLimit, debounceSearch, fromDate || null, toDate || null)
        .then((data) => {
          setVendor(data.data.vendors.rows);
          setVendorTotal(data.data.vendors.totalItems);
        })
        .catch((err) => console.log(err));
    }
  }

  const handleManagedByChange = async (vendorDetails, email) => {
    await approveVendor(vendorDetails.id, false, { manage_by: email });
    if (isChildUser) {
      getVendorChildUsers(vendorPage, vendorLimit, debounceSearch, userid).then((data) => {
        setVendor(data.data.result);
        setVendorTotal(data.data.count);
      });
    } else {
      getAllVendors(vendorPage, vendorLimit, debounceSearch)
        .then((data) => {
          setVendor(data.data.vendors.rows);
          setVendorTotal(data.data.vendors.totalItems);
        })
        .catch((err) => console.log(err));
    }
  };

  const wfmAccessHandler = async (vendorDetails, enabled) => {
    setUpdatingAccessId(vendorDetails?.id);
    try {
      const { data } = await updateUserProductAccess(vendorDetails?.id, enabled);
      const productAccess = data?.data?.productAccess;
      setVendor((prev) =>
        prev.map((item) =>
          item?.id === vendorDetails?.id
            ? { ...item, product_access: productAccess || item?.product_access }
            : item
        )
      );
      setSuccessMessage(data?.message || `WFM access ${enabled ? "enabled" : "disabled"} successfully`);
      setOpenSnackbar(true);
    } catch (error) {
      setErrorMessage("Error updating WFM access. Please try again.");
      setOpenSnackbar(true);
    } finally {
      setUpdatingAccessId(null);
    }
  };

  const handleClearAll = () => {
    setFromDate("");
    setToDate("");
    setVendorPage(0);
  };

  return (
    <div className={`p-5 shadow-md bg-white ${isChildUser ? 'mt-8 m-8' : ''}`}>
      {open && <DeactivateUserModal open={open} setOpen={setOpen} title={"Delete this Vendor"} deactivateUser={removeVendor} />}
      {showAddVendorModal && (
        <SignupForm
          open={showAddVendorModal}
          onClose={() => setShowAddVendorModal(false)}
          onSubmit={handleAddVendor}
          title="Add New Vendor"
          submitButtonText="Create Vendor"
          isLoading={isCreatingVendor}
        />
      )}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-4 gap-3">
        <div className="flex flex-col">
          <h3 className="text-lg uppercase tracking-wider font-bold text-[#2EBAA3]">
            {isChildUser ? 'Child Users' : 'Vendors'}
          </h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              Total:
            </span>
            <span className="text-sm font-semibold text-gray-700 bg-gray-100 px-2 py-0.5 rounded">
              {vendorTotal}
            </span>
          </div>
        </div>
        <div className="flex flex-wrap items-end gap-2">
          {(isAdmin || userPermissions.includes('user-manager')) && (
            <Button 
              variant="contained" 
              style={{ backgroundColor: "#2EBAA3", textTransform: 'none', color: "#fff", height: '38px' }}
              onClick={() => setShowAddVendorModal(true)}
            >
              Add Vendor
            </Button>
          )}
          <input
            type="text"
            id="search"
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search"
            className="px-3 py-1.5 form-control block text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out focus:outline-none"
            style={{ minWidth: '200px', height: '38px' }}
          />
          <div className="flex flex-col">
            <label className="block text-xs font-medium text-gray-700 mb-1">Start Date</label>
            <DatePicker
              selected={fromDate ? new Date(fromDate) : null}
              onChange={(date) => {
                setFromDate(date ? date.toISOString().split("T")[0] : "");
                setVendorPage(0); // Reset pagination when date changes
              }}
              dateFormat="dd-MM-yyyy"
              placeholderText="dd/mm/yyyy"
              maxDate={new Date()}
              className="px-2 py-1 border border-gray-300 rounded-lg text-sm w-32"
              style={{ height: '38px' }}
            />
          </div>
          <div className="flex flex-col">
            <label className="block text-xs font-medium text-gray-700 mb-1">End Date</label>
            <DatePicker
              selected={toDate ? new Date(toDate) : null}
              onChange={(date) => {
                setToDate(date ? date.toISOString().split("T")[0] : "");
                setVendorPage(0); // Reset pagination when date changes
              }}
              dateFormat="dd-MM-yyyy"
              minDate={fromDate ? new Date(fromDate) : null}
              maxDate={new Date()}
              placeholderText="dd/mm/yyyy"
              className="px-2 py-1 border border-gray-300 rounded-lg text-sm w-32"
              style={{ height: '38px' }}
            />
          </div>
          <button
            onClick={handleClearAll}
            className="px-3 py-1 text-sm bg-[#2EBAA3] text-white rounded-lg shadow-md hover:bg-[#26a691] transition-colors duration-200"
            style={{ height: '38px' }}
          >
            Clear All
          </button>
        </div>
      </div>
      <br />
      <div class="overflow-x-auto relative">
        <table class="w-full text-sm text-left text-gray-500">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            {vendorListHeaders.map(renderVendorList)}
            {!isChildUser && <th scope="col" class="py-3 px-6 uppercase">Company</th>}
            {!isChildUser && <th scope="col" class="py-3 px-6 uppercase">Source</th>}
            {!isChildUser && <th scope="col" class="py-3 px-6 uppercase">Preferences</th>}
            {!isChildUser && <th scope="col" class="py-3 px-6 uppercase">Status</th>}
            {!isChildUser && (isAdmin || userPermissions.includes('user-manager')) && <th scope="col" class="py-3 px-6 uppercase">Managed By</th>}
            {!isChildUser && !userPermissions.includes('sales-access') && <th scope="col" class="py-3 px-6 uppercase">Self Managed Resources</th>}
            {!isChildUser && (isAdmin || userPermissions.includes('user-manager')) && (
              <>
              <th scope="col" class="py-3 px-6 uppercase">Post Client Jobs</th>
              <th scope="col" class="py-3 px-6 uppercase">Vendor Pool</th>
              <th scope="col" class="py-3 px-6 uppercase">WFM Access</th>
              <th scope="col" class="py-3 px-6 uppercase">Action</th>
              </>
            )}
          </tr>
          </thead>
          <tbody>
            {vendorMapping?.map((vend, index) => {
              return (
                <tr class="bg-white border-b hover:bg-slate-50">
                  <th
                    scope="row"
                    class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap cursor-pointer"
                    // onClick={(e) => viewCustomer(e, customer._id)}
                    key={index}
                  >
                    {index + 1}
                  </th>
                  <td class="py-4 px-6 whitespace-nowrap" style={{ minWidth: '180px' }}>
                    {vend?.createdAt 
                      ? `${vend.createdAt.split("T")[0]} (${new Date(vend.createdAt).toLocaleString('en-US', {
                          hour: 'numeric',
                          minute: '2-digit',
                          hour12: true
                        }).toLowerCase()})`
                      : '--'}
                  </td>
                  {isChildUser ? (
                    <td class="py-4 px-6">
                      {vend?.firstName ? vend?.firstName + " " + vend?.lastName : vend?.name || ''}
                    </td>
                  ) : (
                    <td class="py-4 px-6 cursor-pointer hover:underline" onClick={() => handleNavigateVendorInfo(vend?.id, `${vend?.company}`)}>
                      {vend?.firstName ? vend?.firstName + " " + vend?.lastName : vend?.name || ''}
                    </td>
                  )}
                  <td class="py-4 px-6">{vend?.username}</td>
                  {/* <td class="py-4 px-6">{vend.clients}</td>
                  <td class="py-4 px-6">{vend.vendors}</td>
                  <td class="py-4 px-6">{vend.resources}</td> */}
                  <td class="py-4 px-6">{vend?.email}</td>
                  <td class="py-4 px-6">{vend?.country ? vend?.country : countryData.find(c => c.countryCodes.includes(vend.countryCode))?.country || '--'}</td>
                  <td class="py-4 px-2">{vend?.countryCode
                    ? `${vend.countryCode.startsWith('+') ? '' : '+'}${vend.countryCode} ${vend?.phone || ''}`
                    : vend?.phone || ''}</td>
                  {!isChildUser && (
                    <>
                      <td class="py-4 px-6">{vend?.company}</td>
                      <td class="py-4 px-6">
                        {vend?.source ? `${vend?.source}` : '--'}
                        {(() => {
                          const parts = [
                            vend?.utm_medium,
                            vend?.utm_campaign,
                          ].filter(part => part?.trim());

                      return parts.length > 0 ? ` | ${parts.join(' | ')}` : <span className="italic text-gray-400 text-center tect-lg"></span>;
                    })()}
                    </td>
                  {vend?.jobAccessType ? 
                  <td class="py-4 px-1 text-center">
                    <Tooltip
                      title={
                        <ul className="text-sm list-disc pl-4">
                          {vend?.jobAccessType && <li>{vend?.jobAccessType}</li>}
                          {vend?.aiInterviewPreference &&<li>{vend?.aiInterviewPreference}</li>}
                        </ul>
                      }
                      arrow
                      placement="top"
                    >
                      <IconButton>
                        <InfoOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </td> : <td className="py-4 px-1 text-center">--</td>}
                  <td class="py-4 px-6">
                    <b>
                      {vend?.isAccountApproved ? "Active" : "Approval Pending"}
                    </b>
                  </td>
                   {(isAdmin || userPermissions.includes('user-manager')) && (
                        <td class="py-4 px-6">
                          {MANAGE_BY_EMAIL_MAP[vend?.manage_by] ? (
                            <span className="font-semibold text-gray-700">{MANAGE_BY_EMAIL_MAP[vend?.manage_by]}</span>
                          ) : (
                            <FormControl size="small" sx={{ minWidth: 120 }}>
                              <Select
                                value=""
                                displayEmpty
                                onChange={(e) => handleManagedByChange(vend, e.target.value)}
                              >
                                <MenuItem value="" disabled>Select</MenuItem>
                                {MANAGE_BY_OPTIONS.map((option) => (
                                  <MenuItem key={option.email} value={option.email}>
                                    {option.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                        </td>
                      )}
                  {!userPermissions.includes('sales-access') && (
                  <td class="py-4 px-6">
                    <Switch
                      checked={vend?.selfManagedResources}
                      onChange={(e) => switchHandler(vend, e.target.checked)}
                      color="primary"
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </td>
                  )}
                  {(isAdmin || userPermissions.includes('user-manager')) && (
                    <>
                    <td class="py-4 px-6">
                    <Switch
                      checked={vend?.showCompanyNameInJobPost}
                      onChange={(e) => showCompanyNameSwitchHandler(vend, e.target.checked)}
                      color="primary"
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </td>
                  <td class="py-4 px-6">
                    <Switch
                      checked={vend?.show_in_vendor_pool || false}
                      onChange={(e) => vendorPoolSwitchHandler(vend, e.target.checked)}
                      color="primary"
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </td>
                    <td class="py-4 px-6">
                    <Switch
                      checked={hasAddonProductAccess(vend?.product_access)}
                      disabled={updatingAccessId === vend?.id}
                      onChange={(e) => wfmAccessHandler(vend, e.target.checked)}
                      color="primary"
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </td>
                    <td class="py-4 px-6">
                      <div className="grid gap-2 grid-cols-3">
                        <IconButton
                          aria-label="delete"
                          onClick={(e) => (e.preventDefault(), setOpen(true), setVendorInfo({ id: vend?.id }))}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    </td>
                    </>
                  )}
                  </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <TablePagination
        component="div"
        count={vendorTotal}
        page={vendorPage}
        onPageChange={handleChangePage}
        rowsPerPage={vendorLimit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
      />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity={errorMessage ? "error" : "success"}
          sx={{ width: '100%' }}
        >
          {errorMessage || successMessage}
        </MuiAlert>
      </Snackbar>

    </div>
  );
};

export default VendorUserList;
